import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {map, take} from "rxjs/operators";

import {SideSheetService} from "@app/presentation/services/side-sheet/side-sheet.service";
import {DisplayService} from "@app/presentation/services/display.service";
import {PlatformService} from "@app/presentation/services/platform.service";
import {LocalizedRouter} from '@app/presentation/services/localized-router';
import {routesNames} from "@app/app-routing.module";


export const isMobileGuard: CanActivateFn = (route, state) => {
  const sideSheetService = inject(SideSheetService);
  const displayService = inject(DisplayService);
  const platformService = inject(PlatformService);
  const localizedRouter = inject(LocalizedRouter);

  const isMobile$ = displayService.isMobileDisplay$;

  return isMobile$.pipe(
    take(1),
    map(isMobile => {
      if (!isMobile && route.routeConfig?.component != null) {
        if (platformService.isServer && !platformService.isMobile) {
          return localizedRouter.createUrlTree(['/', routesNames.home]);
        }
        sideSheetService.open(route.routeConfig?.component, {
          data: {
            queryParams: route.queryParams
          }
        });
      }
      return isMobile;
    })
  );
};
